module.exports = __webpack_public_path__ + "static/media/Hotel-1@2x.ba91c902.png";